import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/ServicePage.css';
import { setPageMeta } from '../utils/seo';

const ODConsultancy = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
    setPageMeta(
      'OD & Management Consultancy | HRCONSOL',
      'Organizational design, change management, leadership development, and culture programs to build high-performance organizations.'
    );
  }, []);

  return (
    <div className="service-page">
      <div className="service-hero">
        <div className="container">
          <h1>OD & Management Consultancy – Building High-Performance Organizations</h1>
          <p className="subtitle">HRCONSOL's Organizational Development and Management Consultancy services help businesses optimize culture, structure, and processes for sustainable growth and competitive advantage.</p>
        </div>
      </div>

      <div className="container">
        <div className="service-content">
          <div className="service-section">
            <p>Organizational success goes beyond hiring the right people—it's about creating systems, structures, and cultures that enable high performance. HRCONSOL's <strong>OD & Management Consultancy</strong> services help companies transform their operations, enhance leadership capabilities, and build resilient organizations.</p>
            <p>From change management to organizational restructuring, we partner with businesses to drive meaningful, lasting transformation.</p>
          </div>

          <div className="service-section">
            <h2>Scope of Services</h2>
            <p>Our OD & Management Solutions Include:</p>
            <div className="process-steps">
              <div className="step">
                <h3><i className="fas fa-sitemap"></i> Organizational Design & Restructuring</h3>
                <p>Designing optimal org structures, reporting lines, and role clarity.</p>
              </div>
              <div className="step">
                <h3><i className="fas fa-exchange-alt"></i> Change Management</h3>
                <p>Leading transformations, mergers, acquisitions, and cultural shifts.</p>
              </div>
              <div className="step">
                <h3><i className="fas fa-users-cog"></i> Leadership Development</h3>
                <p>Building leadership pipelines, succession planning, and executive coaching.</p>
              </div>
              <div className="step">
                <h3><i className="fas fa-chart-line"></i> Performance Improvement</h3>
                <p>Enhancing productivity, efficiency, and operational excellence.</p>
              </div>
              <div className="step">
                <h3><i className="fas fa-heart"></i> Culture & Engagement</h3>
                <p>Building positive cultures, improving employee engagement, and retention.</p>
              </div>
              <div className="step">
                <h3><i className="fas fa-balance-scale"></i> Competency Framework</h3>
                <p>Defining role competencies, skill matrices, and career pathways.</p>
              </div>
              <div className="step">
                <h3><i className="fas fa-project-diagram"></i> Process Optimization</h3>
                <p>Streamlining workflows, reducing inefficiencies, and improving operations.</p>
              </div>
              <div className="step">
                <h3><i className="fas fa-bullseye"></i> Strategic HR Planning</h3>
                <p>Aligning HR strategy with business goals and future workforce needs.</p>
              </div>
            </div>
          </div>

          <div className="service-section">
            <h2>Industries We Serve</h2>
            <ul className="benefits-list">
              <li><i className="fas fa-industry"></i> Manufacturing & Production</li>
              <li><i className="fas fa-university"></i> Banking & Financial Services</li>
              <li><i className="fas fa-laptop-code"></i> IT & Technology</li>
              <li><i className="fas fa-pills"></i> Healthcare & Pharmaceuticals</li>
              <li><i className="fas fa-shopping-cart"></i> Retail & FMCG</li>
              <li><i className="fas fa-truck"></i> Logistics & Supply Chain</li>
              <li><i className="fas fa-bolt"></i> Energy & Utilities</li>
              <li><i className="fas fa-graduation-cap"></i> Education & Training</li>
              <li><i className="fas fa-leaf"></i> NGOs & Development Sector</li>
              <li><i className="fas fa-phone"></i> Telecommunications</li>
            </ul>
          </div>

          <div className="service-section">
            <h2>Why Choose HRCONSOL OD Consultancy?</h2>
            <p className="track-record-intro"><strong>Measurable Impact:</strong></p>
            <ul className="benefits-list">
              <li>
                <span className="benefit-heading">150+ Organizations Transformed</span>
                <span className="benefit-subheading">across diverse industries and sizes</span>
              </li>
              <li>
                <span className="benefit-heading">40% Improvement in Productivity</span>
                <span className="benefit-subheading">through optimized processes and structures</span>
              </li>
              <li>
                <span className="benefit-heading">85% Employee Satisfaction</span>
                <span className="benefit-subheading">post-implementation of culture programs</span>
              </li>
              <li>
                <span className="benefit-heading">Custom Solutions</span>
                <span className="benefit-subheading">tailored to your industry, size, and challenges</span>
              </li>
              <li>
                <span className="benefit-heading">Expert Consultants</span>
                <span className="benefit-subheading">with 15+ years of OD and management experience</span>
              </li>
              <li>
                <span className="benefit-heading">Data-Driven Approach</span>
                <span className="benefit-subheading">using assessments, surveys, and analytics</span>
              </li>
            </ul>
          </div>

          <div className="service-section">
            <h2>Our Consultancy Process</h2>
            <div className="process-steps">
              <div className="step">
                <h3>Step 1: Organizational Assessment</h3>
                <p>Diagnosing challenges through surveys, interviews, and data analysis.</p>
              </div>
              <div className="step">
                <h3>Step 2: Strategy Development</h3>
                <p>Creating customized OD roadmaps and action plans.</p>
              </div>
              <div className="step">
                <h3>Step 3: Implementation</h3>
                <p>Executing changes with stakeholder engagement and communication.</p>
              </div>
              <div className="step">
                <h3>Step 4: Training & Development</h3>
                <p>Building capabilities through workshops and coaching.</p>
              </div>
              <div className="step">
                <h3>Step 5: Monitoring & Optimization</h3>
                <p>Tracking progress, measuring impact, and continuous improvement.</p>
              </div>
            </div>
          </div>

          <div className="service-section">
            <h2>Packages Details</h2>
            
            <div className="process-steps">
              <div className="step package-card">
                <h3>1. ASSESSMENT</h3>
                <p>Organizational Diagnosis & Recommendations</p>
                <ul className="package-list">
                  <li>Fee: PKR 200,000 (one-time)</li>
                  <li>Organizational health assessment</li>
                  <li>Culture & engagement survey</li>
                  <li>Gap analysis report</li>
                  <li>Strategic recommendations</li>
                </ul>
                <p className="package-note">Perfect for understanding current state and identifying opportunities.</p>
                <button onClick={() => navigate('/#contact')} className="package-button">Choose Plan</button>
              </div>

              <div className="step package-card">
                <h3>2. TRANSFORMATION</h3>
                <p>Full OD Implementation (6-Month Engagement)</p>
                <ul className="package-list">
                  <li>Fee: PKR 600,000</li>
                  <li>Organizational restructuring</li>
                  <li>Change management program</li>
                  <li>Leadership development workshops</li>
                  <li>Process optimization</li>
                  <li>Monthly progress reviews</li>
                </ul>
                <p className="package-note">Comprehensive transformation for sustainable growth.</p>
                <button onClick={() => navigate('/#contact')} className="package-button">Choose Plan</button>
              </div>

              <div className="step package-card">
                <h3>3. ONGOING PARTNERSHIP</h3>
                <p>Retainer-Based Advisory (Annual)</p>
                <ul className="package-list">
                  <li>Fee: PKR 150,000/month</li>
                  <li>Continuous OD support</li>
                  <li>Quarterly strategy sessions</li>
                  <li>Leadership coaching</li>
                  <li>Culture & engagement monitoring</li>
                  <li>On-demand consultancy</li>
                </ul>
                <button onClick={() => navigate('/#contact')} className="package-button">Choose Plan</button>
              </div>
            </div>
          </div>

          <div className="service-cta">
            <h2>Ready to Transform Your Organization?</h2>
            <p>Let HRCONSOL help you build a high-performance, future-ready organization.</p>
            <button onClick={() => navigate('/#contact')} className="cta-button">Contact Us</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ODConsultancy;
